import Vue from 'vue'
import moment from 'moment'
import useragent from 'useragent'
import { currency, kilogram, strLimit } from '../config/functions';

function load () {
  Vue.filter('currency', function (value) {
    if (value != null) {
      return currency(value)
    }

    return '-'
  })

  Vue.filter('kilogram', function (value) {
    return kilogram(value)
  })

  Vue.filter('strLimit', function (value, limit, finalStr) {
    return strLimit(value, limit, finalStr)
  })

  Vue.filter('prettyDate', function (value) {
    return moment(value).utc().format('DD [de] MMMM [de] YYYY').toLowerCase()
  })

  Vue.filter('prettyDateAndTime', function (value) {
    return moment(value).utc().format('DD [de] MMMM [de] YYYY [às] HH:mm').toLowerCase()
  })

  Vue.filter('prettyDateWithoutYear', function (value) {
    return moment(value).utc().format('DD [de] MMMM [às] HH:mm').toLowerCase()
  })

  Vue.filter('datetime', function (value) {
    return moment(value).utc().format('DD/MM/YYYY HH:mm')
  })

  Vue.filter('date', function (value) {
    return moment(value).utc().format('DD/MM/YYYY')
  })

  Vue.filter('time', function (value) {
    return moment(value).utc().format('HH:mm')
  })

  Vue.filter('userAgentOS', function (value) {
    return useragent.parse(value).os.toString()
  })

  Vue.filter('userAgentDevice', function (value) {
    return useragent.parse(value).toAgent()
  })

  Vue.filter('boolean', function (value) {
    return value ? 'Sim' : 'Não'
  })

  Vue.filter('minutes', function (value) {
    return value == null ? '-' : parseInt(value) + ' minutos'
  })

  Vue.filter('orderStatusColor', function (value) {
    switch (value) {
      case 'Adicionando':
        return 'grey'
      case 'Em andamento':
        return 'green'
      case 'Fechada':
        return 'primary'
      case 'Cancelada':
        return ''
    }
  })

  Vue.filter('fileSize', function (size) {
    if (size >= 1000000000) {
      return (size / 1000000000).toFixed(2).replace('.', ',') + ' GB'
    } else if (size >= 1000000) {
      return (size / 1000000).toFixed(2).replace('.', ',') + ' MB'
    } else if (size >= 1000) {
      return (size / 1000).toFixed(2).replace('.', ',') + ' kB'
    }

    return size + ' b'
  })

  Vue.filter('sum', function (arr, options) {
    const result = arr.reduce((previousValue, currentValue) => previousValue + currentValue, 0)
    return options.currency
      ? currency(result)
      : new Intl.NumberFormat('pt-BR').format(result)
  })
}

export default { load }



// WEBPACK FOOTER //
// ./src/filters/index.js